const appName = process.env.REACT_APP_NAME;
let brandLogo = null;
try {
  brandLogo = require(`@/assets/images/${appName}/horizontal-logo.svg`);
} catch (e) {
  brandLogo = null;
}

function InfoIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-12 w-12 text-slate-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.5}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
      />
    </svg>
  );
}

export default function PublicRegistrationClosed() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* ── Hero (calm slate) ── */}
      <header className="bg-gradient-to-br from-slate-800 via-slate-700 to-slate-600">
        <div className="mx-auto max-w-3xl px-6 py-12 sm:py-16">
          {brandLogo && (
            <img
              src={brandLogo}
              alt={appName}
              className="mb-10 h-14 w-auto rounded-md bg-white/95 px-4 py-2.5 shadow-sm"
            />
          )}
          <div className="inline-flex items-center gap-1.5 rounded-full bg-slate-500/30 px-3 py-1 text-xs font-semibold text-slate-300 ring-1 ring-slate-400/30">
            <span
              className="h-1.5 w-1.5 rounded-full bg-slate-400"
              aria-hidden="true"
            />
            Processo seletivo
          </div>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">Inscrições encerradas</h1>
          <p className="mt-3 text-lg text-slate-300">Este processo seletivo não está aceitando inscrições no momento.</p>
        </div>
      </header>

      {/* ── Content card ── */}
      <div className="relative mx-auto -mt-8 max-w-3xl px-4 pb-6 sm:px-6">
        <div className="overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-slate-200/50">
          <div className="flex flex-col items-center px-6 py-12 text-center sm:px-8">
            <InfoIcon />
            <h2 className="mt-4 text-xl font-semibold text-slate-900">Período de inscrições não disponível</h2>
            <p className="mt-2 max-w-md text-slate-500">As inscrições para este seletivo podem ter sido encerradas ou ainda não iniciado. Entre em contato com sua regional para mais informações.</p>
          </div>

          <div className="border-t border-slate-200 bg-slate-50 px-6 py-6 text-center sm:px-8">
            <p className="text-sm text-slate-500">Se você acredita que isso é um erro, entre em contato com a Estudologia.</p>
          </div>
        </div>
      </div>

      <footer className="mx-auto max-w-3xl px-4 pb-12 pt-4 text-center sm:px-6">
        <p className="text-sm text-slate-500">Dúvidas? Entre em contato com sua regional.</p>
      </footer>
    </div>
  );
}
